<!-- Payment -->
<div class="row mb-4 mt-0">
  <div class="col-12 col-sm-6">
    <div class="circle-date">
      <ng-container *ngIf="formStep">
        <span class="circle-number">{{ formStep }}</span>
        {{ 'byt_payment' | translate }}
      </ng-container>
      <ng-container *ngIf="!formStep">
        {{ 'byt_paymentData' | translate }}
      </ng-container>
    </div>
  </div>
  <div class="col-12 col-sm-6 pt-4 pt-sm-0 text-left text-sm-end payment-logos">
    <img class="mr-2" src="assets/images/logos/visa-logo.jpg" />
    <img class="mr-2" src="assets/images/logos/mastercard-logo.jpg" />
    <img class="mr-2" src="assets/images/logos/american-express.jpg" />
    <img class="mr-2" src="assets/images/logos/secure.png" />
  </div>

  <div class="pt-3">
    <div class="alert alert-info mb-1" role="alert">
      <i class="fa fa-info-circle"></i>
      {{ 'byt_checkout_paymentInfo' | translate }}
    </div>
  </div>
</div>

<!-- card holder name -->
<div class="form-group row mb-4" [formGroup]="formGroup">
  <div class="col-12">
    <label class="d-none">{{ 'creditcard_name' | translate }}*</label>
    <input
      type="text"
      class="form-control"
      formControlName="account_holder"
      required
      placeholder="{{ 'creditcard_name' | translate }}*" />
  </div>
</div>

<div
  class="form-group form-group-payment mx-0 mb-4"
  [ngClass]="{ invalid: !isValid }">
  <label class="d-none">{{ 'creditcard_number' | translate }}*</label>
  <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions">
  </ngx-stripe-card>
</div>
